import { Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import Button from '../../../components/form-control/Button';
import SelectDropdown, { ISelectDropdownItem } from '../../../components/form-control/SelectDropdown';
import { addPoliciestoCommunity, getAllCommunities } from '../../../api/requests';
import { Community } from '../../../models/community/Community';
import { showToast } from '../../../utils/miscFunctions';

const AssignPolicyToCommunity = ({
  onProceed,
  onClose,
  policyNumbers
}: {
  onProceed: () => void;
  onClose: () => void;
  policyNumbers: [];
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [communities, setCommunities] = useState<any>([]);

  useEffect(() => {
    getCommunities();
  }, []);

  const getCommunities = (page = 0) => {
    getAllCommunities(page, 10)
      .then((response: any) => {
        setCommunities(response?.data?.data);
      })
      .catch((error: Error) => {
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const submitHandler = (values: any) => {
    setSubmitting(true);

    const payload = {
      policyNumbers: policyNumbers
    };

    addPoliciestoCommunity(values.id, payload)
      .then((response: any) => {
        if (response) {
          showToast.success(response.message ?? 'Insurer user account invite sent successfully',);
          onProceed();
        }
      })
      .catch((error: any) => {
        showToast.error(error?.description ?? error?.message,);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="">
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            id: ''
          }}
          validateOnChange={false}
          validateOnBlur
          validationSchema={Yup.object({
            // firstName: Yup.string().trim().required('First name is required.')
          })}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <SelectDropdown
                  label="Select the community the customer belongs to."
                  name="id"
                  listSelectedValue={values.id}
                  onChange={(val: ISelectDropdownItem | null) => {
                    setFieldValue('id', val);
                  }}
                  onBlur={handleBlur}
                  search
                  searchPlaceHolder="Search by community ..."
                  list={communities?.map(
                    (community: Community) =>
                    ({
                      name: community.name,
                      value: community.id
                    } as ISelectDropdownItem)
                  )}
                  placeholder="Select community"
                  error={touched.id ? errors.id : undefined}
                  helperText={touched?.id ? errors.id : undefined}
                />
              </div>

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  label="Submit"
                  onClick={handleSubmit}
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AssignPolicyToCommunity;
